import React from 'react';
import { useFormContext } from 'react-hook-form';

import { MergeElementProps } from '@/core/interfaces/common';
import { Close } from '@/core/components/Icons';

import {
  ClearButton,
  Container,
  FieldErrorMessage,
  Input,
  InputWrapper,
  Label,
} from './TextField.styles';
import { TextFieldSizes } from './TextField.types';

export type TextFieldProps = MergeElementProps<
  'input', {
    name?: string;
    id: string;
    withClearButton?: boolean;
    size?: TextFieldSizes;
  }
>

export const TextField = ({
  name,
  type,
  placeholder,
  id,
  withClearButton = false,
  size = TextFieldSizes.REGULAR,
  ...props
}: TextFieldProps) => {
  const {
    watch,
    register,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const value = watch(id);
  const handleClear = () => {
    setValue(id, '');
    clearErrors(id);
  };

  return (
    <Container>
      {name && (
        <Label
          $isError={!!errors[id]?.message}
          htmlFor={id}
        >
          {name}
        </Label>
      )}
      <InputWrapper>
        <Input
          $isError={!!errors[id]?.message}
          type={type}
          id={id}
          placeholder={placeholder}
          $size={size}
          {...register(id)}
          {...props}
        />
        {withClearButton && value && (
          <ClearButton
            type="button"
            onClick={handleClear}
            aria-label="clear input"
          >
            <Close />
          </ClearButton>
        )}
      </InputWrapper>
      {errors[id]?.message && (
        <FieldErrorMessage>
          {errors[id]?.message as string || ''}
        </FieldErrorMessage>
      )}
    </Container>
  );
};
